export const DashboardFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="sticky top-full px-6 text-opacity-50 sm:text-sm text-xs sm:text-left text-center">
      Copyright Simply Flow © {currentYear}
    </div>
  );
};
